import {Controller} from 'react-hook-form';
import {useTranslation} from 'next-i18next';
import {Form} from '@/_application/core/components/ui/forms/form';
import PhoneInput from '@/_application/core/components/ui/forms/phone-input';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import {standardizePhoneNumber} from '@/lib/phone-utils';
import type { PhoneNumberFormInput, PhoneNumberFormProps } from './otp-login.types';
import { checkoutContactSchema } from './otp-login.schema';

export default function PhoneNumberForm({phoneNumber, onSubmit, isLoading, view}: Readonly<PhoneNumberFormProps>) {
    const {t} = useTranslation('common');

    const handleSubmit = ({phone_number}: {phone_number: string}) => {
        const phone = '0' + phone_number.slice(3);
        const submitData = {
            phone_number: phone,
        };

        onSubmit(submitData);
    };

    return (
        <Form<PhoneNumberFormInput>
            onSubmit={data => handleSubmit({phone_number: standardizePhoneNumber(`+${data.phone_number}`)})}
            validationSchema={checkoutContactSchema}
            className="w-full"
            useFormProps={{
                defaultValues: {
                    phone_number: phoneNumber,
                },
            }}>
            {({control, formState: {errors}, trigger}) => {
                const handleKeyDown = async (e: any) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        const cleanPhoneNumber = e.target.value.replaceAll(/\D/g, '');
                        const isValid = await trigger('phone_number');
                        if (!isValid) {
                            return;
                        }

                        handleSubmit({phone_number: standardizePhoneNumber(`+${cleanPhoneNumber}`)});
                    }
                };
                return (
                    <div className="flex flex-col">
                        <div className="flex w-full flex-col items-center justify-between md:min-w-90">
                            <Controller
                                name="phone_number"
                                control={control}
                                render={({field}) => (
                                    <PhoneInput
                                        areaCodes={{vn: ['']}}
                                        onKeyDown={handleKeyDown}
                                        country="vn"
                                        onlyCountries={['vn']}
                                        enableAreaCodes={false}
                                        disableDropdown
                                        countryCodeEditable={false}
                                        inputClass="p-0! ltr:pr-4! rtl:pl-4! ltr:pl-14! rtl:pr-14! flex! items-center! w-full! appearance-none! transition! duration-300! ease-in-out! !text-heading text-sm! focus:outline-none! focus:ring-0! border! !border-border-base rtl:border-l-0! rounded! focus:border-accent! h-12!"
                                        dropdownClass="focus:ring-0! border! !border-border-base shadow-350!"
                                        {...field}
                                    />
                                )}
                            />
                            {errors.phone_number?.message && (
                                <p className="mb-2 mt-2 text-xs text-red-500 ltr:text-left rtl:text-right">
                                    {t(errors.phone_number.message)}
                                </p>
                            )}
                            <Button
                                aria-label="Gửi số điện thoại"
                                className="mt-2 bg-primary text-sm! uppercase hover:bg-blue-kid!"
                                loading={isLoading}
                                disabled={isLoading}>
                                {view === 'login' ? (
                                    t('text-send-otp')
                                ) : (
                                    <>
                                        {phoneNumber ? t('text-update') : t('text-add')} {t('nav-menu-contact')}
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                );
            }}
        </Form>
    );
}
